
<template>
  <div>

    <!-- search input  -->
    <div class="form-group">

      <label class="control-label" v-if="alias">{{ alias }}:</label>

      <div class="inputSearch">
        <div class="btnDiv" style="">
          <button ref="btn" type="button" :disabled="disabled" class="btn btn-primary btn-sm" @click="openModal" >
            <i class="fa fa-search"></i>
          </button>
        </div>
        <div class="inputDiv" tabindex="0" :class="[{ 'disabled' : disabled }, { 'is-invalid' : getError }]" @blur="validate" :name="name" @click="openModal">
          {{ displayedValue }}
        </div>
      </div>

      <div class="invalid-feedback invalid-feedback-overwrite" style="display:block" v-if="getError">
        {{ getError }}
      </div>

    </div>
    <!-- search input  -->

    <!-- search modal  -->
    <b-modal :title="'Pesquisar ' + alias" ref="modalSearch" @shown="onShow" hide-footer @hide="onHide">
      <div class="modalSearch">

      <!--<loading-overlay :show="showLoading"></loading-overlay>-->

        <!-- search input -->
        <div class="row">
          <div class="col-md-12">
            <form autocomplete="off" @submit.prevent>
              <input
                autocomplete="false"
                :ref="'searchInput'"
                class="form-control"
                v-model="searchText"
                v-debounce:400ms="onInput"
                debounce-events="input"
              />

              <i v-if="isLoading" class="fas fa-circle-notch fa-spin text-primary loading-icon"/>
              <!--<span class="input-group-btn">
                <button class="btn btn-primary" @click="onSearch">
                  <i class="fas fa-search"></i>
                </button>
              </span>-->
            </form>

          </div>
        </div>
        <!-- search input -->

        <br>

        <div class="row">
          <div class="col-md-12">

            <!-- slot -->
            <table-paginator :data="searchResult" @pagechange="onSearch($event)" >
              <slot/>
              <br>
            </table-paginator>
            <!-- slot -->

          </div>
        </div>

      </div>
    </b-modal>

    <GlobalEvents
      v-if="listenersConnected"
      @keyup.down="nextOption"
      @keyup.up="backOption"
      @keyup.enter="select"
    />
    <!-- search modal  -->

  </div>
</template>

<script>

import axios from 'axios'
import GlobalEvents from 'vue-global-events'
import TablePaginator from './../sections/TablePaginator.vue'
//import LoadingOverlay from './LoadingOverlay.vue'

export default {
    components: {
      GlobalEvents,
      TablePaginator,
        //LoadingOverlay
    },



    props: {

      value: {},

      displayedValue: {},

      name : {},

      alias : {},

      form : {},

      disabled: {
        default : false
      },

      searchResult : {},

      isLoading : {
        default : false
      }
    },

    data : function (){

      return {

        searchText : null,

        listenersConnected : false,

        optionPointer : { pointer : 0 }
      }

    },

    provide: function () {

      return {

        onSelected : this.onSelected,

        optionPointer : this.optionPointer

      }
    },

    computed : {



      getError(){

        if (this.form !== {} && this.form !== undefined) {

          return this.form.getErrors(this.name)

        }

        return false
      },

      // pointer() {
      //   return this.optionPointer
      // }

    },

    // watch: {
    //     displayedValue: function (newDisplayedValue, oldDisplayedValue) {
    //         this.dataDisplayedValue = newDisplayedValue
    //     },

    //     value: function (newValue,oldValue) {
    //         if (newValue != '') {
    //             this.validate()
    //         }
    //     }
    // },

    methods: {

      select() {

        if (this.searchResult.data == undefined) {
          return
        }

        if (this.searchResult.data[this.optionPointer.pointer] == undefined) {
          return
        }

        this.$emit('selected', this.searchResult.data[this.optionPointer.pointer] )

        this.onSelected()

      },

      onInput() {
        this.onSearch()
      },

      onSelected() {

        this.hideModal()

        this.searchResult.data = null
        
        this.optionPointer.pointer = null
      },

      validate(event){

        if (this.form != undefined){

          this.form.validate(this.name);
        }

      },


      openModal(){

        this.searchText = "";

        this.optionPointer.pointer = 0

        this.$refs.modalSearch.show();

      },

      onShow(){

        this.$refs.searchInput.focus();

        this.listenersConnected = true
      },

      onHide() {

        this.listenersConnected = false

      },

      hideModal(){

        this.$refs.modalSearch.hide();

      },

      onSearch(page = 1) {

        this.$emit('search', { text : this.searchText, page : page })

        this.optionPointer.pointer = 0

      },

      setFocus(){

        this.$refs.btn.focus()

      },

      nextOption() {

        if (this.optionPointer.pointer < (this.searchResult.data.length -1)) {

          this.optionPointer.pointer++

        }

      },

      backOption() {

        if (this.optionPointer.pointer > 0) {

          this.optionPointer.pointer--

        }

      },



    }
};
</script>

<style>
    .loading-icon {

      position: absolute;
      top: 12px;
      right: 22px;

    }

    .inputSearch {
        display: flex;
    }

    .inputSearch .btnDiv {
        padding-right: 10px;
    }

    .inputSearch .inputDiv {
        font-size: 0.875rem;
        padding: 0.25rem 0.5rem;

        width: 100%;
        display: block;

        border: 1px solid #ced4da;
        border-radius: 0.2rem;
        transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
    }


    .inputSearch .inputDiv:focus {
        color: #495057;
        background-color: #fff;
        border-color: #2c6fc0;
        outline: none;
        box-shadow: 0 0 0 0.2rem rgba(20, 51, 88, 0.25);
    }

    .inputSearch .inputDiv.disabled {
        background-color: #e9ecef;
        opacity : 1;
    }

    .inputSearch .inputDiv.is-invalid {
        border-color: #dc3545;
    }

    .inputSearch .inputDiv.is-invalid:focus {
        box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
    }

    .activeRow {
        color : #fff;
        background-color : #143358;
    }

</style>
